module.exports = __webpack_public_path__ + "img/16367385373_8fcff25248_b.jpg";